<div class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
  <div
    class="toast fade show realtime-toast"
    role="status"
    tabindex="0"
    *ngFor="let toast of realtimeToasts.toasts()"
    (click)="open(toast)"
    (keydown.enter)="open(toast)"
  >
    <div class="toast-header">
      <span class="avatar avatar-xs me-2 realtime-toast-icon" [ngClass]="'realtime-toast-' + toast.kind" aria-hidden="true">
        <svg *ngIf="toast.kind === 'notification'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"/><path d="M9 17v1a3 3 0 0 0 6 0v-1"/></svg>
        <svg *ngIf="toast.kind === 'email'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"/><path d="M4 13h3l3 3h4l3 -3h3"/></svg>
        <svg *ngIf="toast.kind === 'chat'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 20l1.3 -3.9a8 8 0 1 1 3.4 2.9z"/><path d="M8 9h8M8 13h6"/></svg>
      </span>
      <strong class="me-auto text-truncate">{{ toast.title }}</strong>
      <small class="text-secondary">now</small>
      <button type="button" class="ms-2 btn-close" [attr.aria-label]="'Dismiss ' + iconLabel(toast)" (click)="dismiss(toast, $event)"></button>
    </div>
    <div class="toast-body">{{ toast.message }}</div>
  </div>
</div>
